import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { AdminApp } from "./AdminApp.js";
import "@fontsource-variable/onest";
import "./styles.css";

createRoot(document.getElementById("root")!).render(<StrictMode><AdminApp /></StrictMode>);
